import React from 'react';
import { FormattedMessage } from 'react-intl';

// Order is done manually for both languages because I couldn't find a way to
// convert FormattedMessage before render for sorting. Sorry for that.

const options = [
  {
    value: 0,
    label: <FormattedMessage id="category.SelectCategory" />,
  },
  {
    value: 'Agriculture, forestry and fishing',
    label: <FormattedMessage id="category.Agriculture" />,
    enOrder: 1,
    fiOrder: 1,
  },
  {
    value: 'Mining and quarrying',
    label: <FormattedMessage id="category.Mining" />,
    enOrder: 2,
    fiOrder: 2,
  },
  {
    value: 'Industrial',
    label: <FormattedMessage id="category.Industrial" />,
    enOrder: 3,
    fiOrder: 3,
  },
  {
    value: 'Electricity, gas and heat supply, refrigeration business',
    label: <FormattedMessage id="category.Electricity" />,
    enOrder: 4,
    fiOrder: 4,
  },
  {
    value: 'Water supply, sewerage, waste management and remediation activities',
    label: <FormattedMessage id="category.Water" />,
    enOrder: 5,
    fiOrder: 5,
  },
  {
    value: 'Construction',
    label: <FormattedMessage id="category.Construction" />,
    enOrder: 6,
    fiOrder: 6,
  },
  {
    value: 'Wholesale and retail trade',
    label: <FormattedMessage id="category.Wholesale" />,
    enOrder: 7,
    fiOrder: 7,
  },
  {
    value: 'Shipping and storage',
    label: <FormattedMessage id="category.Shipping" />,
    enOrder: 8,
    fiOrder: 8,
  },
  {
    value: 'Accommodation and food service activities',
    label: <FormattedMessage id="category.Accommodation" />,
    enOrder: 9,
    fiOrder: 9,
  },
  {
    value: 'Information and communication',
    label: <FormattedMessage id="category.Information" />,
    enOrder: 10,
    fiOrder: 10,
  },
  {
    value: 'Financial and insurance activities',
    label: <FormattedMessage id="category.Financial" />,
    enOrder: 11,
    fiOrder: 11,
  },
  {
    value: 'Real estate activities',
    label: <FormattedMessage id="category.Realestate" />,
    enOrder: 12,
    fiOrder: 12,
  },
  {
    value: 'Professional, scientific and technical activities',
    label: <FormattedMessage id="category.Professional" />,
    enOrder: 13,
    fiOrder: 13,
  },
  {
    value: 'Administrative and support service activities',
    label: <FormattedMessage id="category.Administrative" />,
    enOrder: 14,
    fiOrder: 14,
  },
  {
    value: 'Public administration and defense; compulsory social securityg',
    label: <FormattedMessage id="category.Public" />,
    enOrder: 15,
    fiOrder: 15,
  },
  {
    value: 'Training',
    label: <FormattedMessage id="category.Training" />,
    enOrder: 16,
    fiOrder: 16,
  },
  {
    value: 'Health and social services',
    label: <FormattedMessage id="category.Health" />,
    enOrder: 17,
    fiOrder: 17,
  },
  {
    value: 'Arts, entertainment and recreation',
    label: <FormattedMessage id="category.Arts" />,
    enOrder: 18,
    fiOrder: 18,
  },
  {
    value: 'Other service activities',
    label: <FormattedMessage id="category.Other" />,
    enOrder: 19,
    fiOrder: 19,
  },
  {
    value: 'Industry unknowns',
    label: <FormattedMessage id="category.unknown" />,
    enOrder: 20,
    fiOrder: 20,
  },
];

export default options;
